export default {
  keyword: undefined,
  alias: undefined,
  createdBy: undefined,
};
